import { ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { z } from "zod"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * @name createStepSchema
 * @description Create a schema for a multi-step form
 * @param steps
 */
export function createStepSchema<T extends Record<string, z.ZodType>>(
  steps: T,
) {
  return z.object(steps)
}

/**
 * @name formatFileMimeTypes
 * @description Format a list of file mime types to a readable string
 * @param types
 */
export function formatFileMimeTypes(types: string[]) {
  return types
    .map((type) => type.split("/")[1])
    .map((ext) => `.${ext}`)
    .join(", ")
}

export function ensureInputPrefix(
  prefix: string,
  e: React.ChangeEvent<HTMLInputElement>,
): string {
  const value = e.target.value
  if (value === prefix) return prefix
  if (!value || value.length < prefix.length) return prefix
  if (value.startsWith(prefix)) return value
  return prefix + value.slice(prefix.length)
}
